export default __webpack_public_path__ + "static/media/instagram-logo.b79a2487.png";